import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({

    palette: {
        mode: 'dark',
        background: {
            default: '#4A6156',
            paper: '#344B4D'
        },
        text: {
            primary: "#DBEBC0",
            secondary: "#FFFFFF",

        },
        primary: {
            main: '#919088',

        },
        secondary: {
            main: '#db595d',
        }
    },

    typography: {
        htmlFontSize: 18,
        fontFamily: 'Roboto',

    },



    components:
    {
        MuiTextField: {
            variants: [
                {
                    props: { className: 'ultra-dense' },
                    style: {
                        padding: "0px",
                        height: "20px",
                        minWidth: "100px"
                    }
                }
            ]
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    marginTop: "0px"
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: "#70af23",
                    ":visited": {
                        color: '#508372'
                    },

                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    width: "fit-content!important"
                },
                list: {
                    display: "inline-flex"
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                tag: {
                    margin: '1px'
                }
            }
        },

        MuiTab: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: '#70af23',
                        color: '#ffffff'
                    },
                    "&.Mui-selected": {
                        backgroundColor: '#70af23',
                        color: '#ffffff'
                    }
                }
            }
        },

        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    "&.Mui-checked, &.Mui-checked .MuiSwitch-track": {
                        color: "#db595d"
                    }
                },
                thumb: {
                    style: {
                        color: "#db595d"
                    }
                },
                track: {
                    style: {
                        color: "#db595d"
                    }

                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    backgroundColor: 'none',
                    color: '#E4E1DF',
                    userSelect: "none"
                }
            },
            variants: [
                {
                    props: { className: 'ultra-dense' },
                    style: {
                        "& tbody tr td": {
                            padding: 0,
                            paddingLeft: "1px"
                        },
                        "& tbody tr td span": {
                            padding: "2px"
                        },
                        "& thead tr th": {
                            fontSize: "12px",
                            fontWeight: "bold",
                            border: "solid 1px white"
                        }
                    }
                },
                {
                    props: { className: 'ultra-dense-header' },
                    style: {
                        "& tbody tr td": {
                            padding: 0,
                            paddingLeft: "1px"
                        },
                        "& tbody tr td span": {
                            padding: "2px"
                        },
                        "& thead tr th": {
                            padding: 1,
                            paddingLeft: "3px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            border: "solid 1px white"
                        }
                    }
                }

            ]
        },

        MuiTableCell: {
            styleOverrides: {
                footer: {
                    color: "#A39F96",
                },
                stickyHeader: {
                    backgroundColor: "#A39F96",
                    color: "#E4E1DF",
                    top: "-5px"
                },
                root: {
                    borderCollapse: "collapse",
                    backgroundColor: "none",
                    border: "none"
                }
            }
        },

        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: "white"
                }
            }
        },

        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: 'none',
                        color: 'none'
                    },
                    borderCollapse: 'collapse'
                }
            }

        },

        MuiTableFooter: {
            variants: [
                {
                    props: { className: "sticky-footer" },
                    style: {
                        "& tr td": {
                            position: "sticky",
                            bottom: "-5px",
                            backgroundColor: "#A39F96",
                            color: "#E4E1DF",
                            minHeight: "50px",
                            minWidth: "5px"
                        }
                    }
                }
            ]
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderColor: "lavender"
                }
            }
        },

        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: "#F",
                    color: "#919088"
                }
            }
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    width: "100%",
                    margin: "5px"
                }
            }
        },

        MuiStepLabel: {
            styleOverrides: {
                label: {
                    "&.Mui-completed": {
                        color: "green"
                    },
                    "&.Mui-active": {
                        color: "lightblue"
                    }
                }
            }
        },

        MuiStepIcon: {
            styleOverrides: {
                root: {
                    "&.Mui-completed": {
                        color: "green"
                    },
                    "&.Mui-active": {
                        color: "lightblue"
                    }
                }
            }
        }
    },

});
